import "./Selectbox.scoped.scss"
import { selectboxCancelActionState, selectboxCancelTextState, selectboxSelectActionState, selectboxSelectTextState, selectboxMessageState } from "../../atoms/common";
import { getRecoil } from "recoil-nexus";

function Selectbox() {
  const selectboxSelectActions = getRecoil(selectboxSelectActionState);
  const selectboxCancelAction = getRecoil(selectboxCancelActionState);
  const selectboxSelectTexts = getRecoil(selectboxSelectTextState);
  const selectboxCancelText = getRecoil(selectboxCancelTextState);
  const selectboxMessage = getRecoil(selectboxMessageState);

  return (
    <div className="selectbox-warpper">
      <div className="selectbox">
        <div className="selectbox__header">
          <div>선택</div>
        </div>
        <div className="selectbox__contents">
          <div className="selectbox__row" dangerouslySetInnerHTML={{ __html: selectboxMessage.split('\n').join('<br/>')}}>
          </div>
          <div className="selectbox__selects">
            {
                selectboxSelectTexts.map((text, i) => (
                    <button key={i} className="selectbox-button" onClick={selectboxSelectActions[i]}>{text}</button>
                ))
            }
          </div>
          <div className="selectbox__button">
            <button onClick={selectboxCancelAction}>{selectboxCancelText}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Selectbox;